import ertUnassignDeviceComponent from './unassignDevice.component';

const ertUnassignDevice = angular.module('app.components.ertUnassignDeviceComponent', [])
			.component('ertUnassignDevice', ertUnassignDeviceComponent)
			.name;

export default ertUnassignDevice;
